import { z } from 'zod';
import { ROLE_CODES } from '../constants/roles.js';
import { UTILISATEUR_STATUTS } from '../constants/statuses.js';
import { passwordSchema } from './auth.js';
import { paginationQuerySchema } from './common.js';
/**
 * Rôle assignable à un compte. `AGENT_IMMATRICULATION` est conservé dans
 * `ROLE_CODES` pour compatibilité future mais reste hors périmètre applicatif
 * (voir docs/cutover-cnss-sync.md) : ce schéma le rejette explicitement plutôt
 * que de compter sur la seule liste `ASSIGNABLE_ROLE_CODES` côté appelant.
 */
export const assignableRoleCodeSchema = z.enum(ROLE_CODES).refine((role) => role !== 'AGENT_IMMATRICULATION', {
    message: "Le rôle AGENT_IMMATRICULATION est hors périmètre applicatif et ne peut pas être assigné.",
});
export const createUserSchema = z.object({
    nomComplet: z.string().min(3).max(160),
    username: z
        .string()
        .min(3)
        .max(60)
        .regex(/^[a-z0-9._-]+$/i, 'Identifiant : lettres, chiffres, points, tirets uniquement'),
    email: z.string().email().max(160),
    telephone: z.string().max(30).optional(),
    roleCode: assignableRoleCodeSchema,
    siteOperationnelId: z.coerce.number().int().positive().optional(),
    province: z.string().max(80).optional(),
    /** Si omis, un mot de passe temporaire fort est généré et renvoyé une seule fois. */
    password: passwordSchema.optional(),
});
export const updateUserSchema = z.object({
    nomComplet: z.string().min(3).max(160).optional(),
    email: z.string().email().max(160).optional(),
    telephone: z.string().max(30).nullable().optional(),
    siteOperationnelId: z.coerce.number().int().positive().nullable().optional(),
    province: z.string().max(80).nullable().optional(),
});
export const changeUserRoleSchema = z.object({
    roleCode: assignableRoleCodeSchema,
});
export const changeUserStatusSchema = z.object({
    statut: z.enum(['actif', 'suspendu']),
});
export const resetUserPasswordSchema = z.object({
    newPassword: passwordSchema.optional(),
});
export const listUsersQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(160).optional(),
    statut: z.enum(UTILISATEUR_STATUTS).optional(),
    roleCode: z.enum(ROLE_CODES).optional(),
});
//# sourceMappingURL=users.js.map